import { AlertTriangle } from "lucide-react";
import { useWorkspace } from "../context/WorkspaceContext";
import { formatInt } from "../lib/format";

// Compact operational "Action Required" list. Reads ONLY the already-loaded snapshot payload
// (no new live queries) and reuses the existing drill-to-worklist infrastructure.
export default function ActionRequired({ data }) {
  const { drillDown } = useWorkspace();
  if (!data) return null;
  const m = data.materials || {};
  const overdue = data.ground_ageing?.overdue || 0;
  const drillMat = (status, label) => drillDown("material-register", { current_status: status, label });

  const items = [
    { key: "grn", label: "Pending GRN", value: m.grn_pending, dot: "bg-amber-500", onClick: () => drillMat("GRN_PENDING", "Pending GRN") },
    { key: "ack", label: "Pending Acknowledgement", value: m.assigned, dot: "bg-cyan-500", onClick: () => drillMat("ASSIGNED_TO_FIELD_USER", "Pending Acknowledgement") },
    { key: "defective", label: "Defective", value: m.defective, dot: "bg-red-500", onClick: () => drillMat("DEFECTIVE_UNDER_REVIEW", "Defective awaiting checker") },
    { key: "returns", label: "Return Requests", value: m.return_requested, dot: "bg-orange-500", onClick: () => drillMat("RETURN_REQUESTED", "Return Requests") },
    { key: "overdue", label: ">15 Days in Field", value: overdue, dot: "bg-red-600", onClick: () => drillDown("material-register", { label: "Overdue in field (>15 days)" }) },
    { key: "drafts", label: "Draft Data Entries", value: data.draft_entries, dot: "bg-amber-400", onClick: () => drillDown("data-entry-register", { status: "DRAFT", label: "Draft entries" }) },
  ];

  return (
    <div data-testid="action-required">
      <div className="mb-3 mt-8 flex items-center gap-2">
        <AlertTriangle className="h-4 w-4 text-amber-600" />
        <h2 className="font-display text-lg font-semibold text-slate-900">Action Required</h2>
      </div>
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((it) => (
          <button
            key={it.key}
            type="button"
            data-testid={`action-${it.key}`}
            onClick={it.onClick}
            className="flex items-center justify-between rounded-lg border border-slate-200 bg-white px-3.5 py-2.5 text-left shadow-sm transition-all hover:border-teal-300 hover:shadow-md"
          >
            <span className="flex items-center gap-2.5 text-sm text-slate-700">
              <span className={`h-2.5 w-2.5 shrink-0 rounded-full ${it.dot}`} />
              {it.label}
            </span>
            <span className="font-display text-lg font-bold tabular-nums text-slate-900">{formatInt(it.value)}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
